import apiClient from '@u/apiClient'
import GetMarketplaceListController from '@/wayfinder/actions/App/Http/Controllers/Marketplace/GetMarketplaceListController'
import GetMarketplaceSpecificController from '@/wayfinder/actions/App/Http/Controllers/Marketplace/GetMarketplaceSpecificController'
import EnableMarketplaceModuleController from '@/wayfinder/actions/App/Http/Controllers/Marketplace/EnableMarketplaceModuleController'
import DisableMarketplaceModuleController from '@/wayfinder/actions/App/Http/Controllers/Marketplace/DisableMarketplaceModuleController'

export default {
  getMarketplaceListModule({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetMarketplaceListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getMarketplaceSpecificModule({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetMarketplaceSpecificController.get({ module_id: payload.module_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  enableMarketplaceModule({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          EnableMarketplaceModuleController.get({ moduleId: payload.module_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  disableMarketplaceModule({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DisableMarketplaceModuleController.get({
            moduleId: payload.module_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
